import { noOp } from '@/utils/helpers'

import { useUser } from '@/client/context/user'
import useAPIWrapper from '@/client/hooks/useAPIWrapper'
import RPC from '@/client/rpc'
import type { WaitlistName } from '@/client/services/waitlist'

import TextInput from '@/components/TextInput'
import { useToaster } from '@/components/Toast/useToaster'

export default function JoinWaitlistForm({
  waitlistName,
  onSubmit = noOp,
  buttonText = 'Sign Up',
  buttonVariant = 'solid',
  disableToastOnCompletion = false,
  placeholder = 'Enter your email address',
}: {
  waitlistName: WaitlistName
  onSubmit?: (email: string) => void
  buttonText?: string
  buttonVariant?: string
  disableToastOnCompletion?: boolean
  placeholder?: string
}): React.ReactElement {
  const toast = useToaster()
  const user = useUser()

  const [onJoinWaitlist] = useAPIWrapper(
    async (inputtedEmail: string) => {
      if (inputtedEmail.length === 0) {
        toast({
          title: 'Please enter your email address',
          status: 'error',
        })
        return
      }

      await RPC.UNSAFE_addOrUpdateWaitlistSignup({
        email: inputtedEmail,
        waitlistName,
      })

      onSubmit(inputtedEmail)

      if (!disableToastOnCompletion) {
        toast({
          title: `You're signed up!`,
          status: 'success',
        })
      }
    },
    [toast, waitlistName, onSubmit, disableToastOnCompletion],
    'Join Waitlist'
  )

  return (
    <TextInput
      placeholder={placeholder}
      initialValue={user.email.length > 0 ? user.email : undefined}
      size={30}
      onSubmit={onJoinWaitlist}
      disableSubmitOnEnter
      resetOnSubmit
      buttonText={buttonText}
      buttonVariant={buttonVariant}
      disableButtonWithoutInput
      disabled={user.email.length > 0}
    />
  )
}
